import React from "react";
import styled from "styled-components";
import ListItem from "./ListItem";



const ListComponent = ({data, url, category}) => {
    return (
        <StyledComponent className={'list-single-item'} >
            <div className="list">
                {category && <div className="category">
                    <h5>{category}</h5>
                </div>}

                <ListItem
                    hideLink
                    key={data?.product_data?.id || data?.data?.id}  // You should use a unique identifier like id for the key
                    url={`${url}/${data?.product_data?.slug || data?.data?.slug}`}
                    id={data?.product_data?.id || data?.data?.id}
                    title={data?.product_data?.title || data?.data?.title}
                    year={data?.product_data?.design_construction_period}
                    isLocation={data?.product_data?.address}
                    publishedIn={data?.data?.date}
                />

            </div>
        </StyledComponent>
    );
};

const StyledComponent = styled.div`
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 20px;
    margin-bottom: 14px;
    
    &:last-child {
        border-bottom: unset;
    }
    

    .category {
        margin-bottom: 30px;

        h5 {
            font-size: 16px;
            font-weight: bold;
            line-height: 18px;
            font-weight: bold;
        }
    }

    .list {
        ul {
            li {

           

                a {
                    display: flex;
                    justify-content: space-between;
                }
            }
        }

        &__text {
            h5 {
                font-size: 14px;
                font-weight: 400;
                line-height: 16px;
                color: #000;
            }
        }
    }

    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
    }
`;

export default React.memo(ListComponent);
